import styled from "styled-components";

export default styled.div`
    .table {
        table-layout: fixed;
        width: 100%;

        th,
        td {
            width: 12.5%;
        }
    }

    .linkUrl {
        display: inline-flex;
        gap: 6px;
    }
`;
